export default "__VITE_ASSET__CSfgV_WS__"